import Login from "./components/auth/login";
import Register from "./components/auth/register";
import Header from "./components/header";
import Home from "./components/home";
import Users from "./components/users";
import Settings from "./components/settings";
import Projects from "./components/projects";
import ProjectDetail from "./components/project-detail";
import ProtectedRoute from "./components/common/ProtectedRoute";

import { AuthProvider } from "./contexts/authContext";
import { useRoutes } from "react-router-dom";

function App() {
  const routesArray = [
    {
      path: "*",
      element: <Login />,
    },
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/register",
      element: <Register />,
    },
    {
      path: "/home",
      element: <ProtectedRoute><Home /></ProtectedRoute>,
    },
    {
      path: "/projects",
      element: <ProtectedRoute><Projects /></ProtectedRoute>,
    },
    {
      path: "/projects/:projectId/:tab?",
      element: <ProtectedRoute><ProjectDetail /></ProtectedRoute>,
    },
    {
      path: "/users",
      element: <ProtectedRoute roles={['superadmin', 'admin', 'collaborator']}><Users /></ProtectedRoute>,
    },
    {
      path: "/settings",
      element: <ProtectedRoute roles={['superadmin']}><Settings /></ProtectedRoute>,
    },
  ];
  let routesElement = useRoutes(routesArray);
  return (
    <AuthProvider>
      <Header />
      <div className="w-full h-full flex flex-col bg-gray-50 dark:bg-gray-900">{routesElement}</div>
    </AuthProvider>
  );
}

export default App;
